import graphqlRequest from "../skillsMasteryRequest";
import GET_RESOURCES_METADATA from "./getResourcesMetadataGraphql";

/**
 *
 * @param {{resourceUniqueId: string, resourceGroupType: string}[]} filter
 */

export async function getResourcesMetadata(filter) {
  const batchSize = 50;
  const batches = [];
  for (let i = 0; i < filter.length; i += batchSize) {
    batches.push(filter.slice(i, i + batchSize));
  }

  const requests = batches.map(batch =>
    graphqlRequest(GET_RESOURCES_METADATA, { filters: batch })
  );

  const batchResults = await Promise.all(requests);

  // Concatenate the results from each batch
  const combinedResults = batchResults.reduce((acc, currentResponse) => {
    if (
      currentResponse &&
      currentResponse.getResourceMetadata &&
      Array.isArray(currentResponse.getResourceMetadata)
    ) {
      return acc.concat(currentResponse.getResourceMetadata);
    }
    return acc;
  }, []);

  return { getResourceMetadata: combinedResults };
}
